import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  member
} = translate({
  "member": "Member"
});
export const topMember = translateFormatter<{
  i: RichTextFormatter;
}>("<i>Top</i>Member", undefined, undefined, "en");